import { useState } from 'react'
import { Check, Pencil, Trash2, X } from 'lucide-react'

function noteTime(value) {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date)
}

function NoteMessage({ note, canChange, className = '', onUpdate, onDelete }) {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState(note.body || '')
  const [confirming, setConfirming] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const save = async () => {
    const body = draft.trim()
    if (!body || busy) return
    setBusy(true)
    setError('')
    try {
      await onUpdate?.(note, body)
      setEditing(false)
    } catch (err) {
      setError(err.response?.data?.message || 'Não foi possível editar a nota')
    } finally {
      setBusy(false)
    }
  }

  const remove = async () => {
    if (busy) return
    setBusy(true)
    setError('')
    try {
      await onDelete?.(note)
    } catch (err) {
      setError(err.response?.data?.message || 'Não foi possível apagar a nota')
      setBusy(false)
    }
  }

  return (
    <article className={`patients-note-bubble${note.pending ? ' is-pending' : ''} ${className}`.trim()}>
      <div className="patients-note-bubble-meta">
        <strong>{note.author_name || 'Equipe'}</strong>
        <time dateTime={note.created_at}>{noteTime(note.created_at)}</time>
      </div>
      {editing ? (
        <textarea
          className="patients-note-edit"
          value={draft}
          rows={3}
          maxLength={2000}
          onChange={(event) => setDraft(event.target.value)}
        />
      ) : (
        <p>{note.body}</p>
      )}
      {error && <p className="patients-note-inline-error">{error}</p>}
      {canChange && !note.pending && (
        confirming ? (
          <div className="patients-note-bubble-actions">
            <span>Apagar esta nota?</span>
            <button type="button" onClick={remove} disabled={busy}>Apagar</button>
            <button type="button" onClick={() => setConfirming(false)} disabled={busy}>Cancelar</button>
          </div>
        ) : (
          <div className="patients-note-bubble-actions">
            {editing ? (
              <>
                <button type="button" onClick={save} disabled={busy || !draft.trim()}>
                  <Check size={14} /> Salvar
                </button>
                <button type="button" onClick={() => { setEditing(false); setDraft(note.body || ''); setError('') }} disabled={busy}>
                  <X size={14} /> Cancelar
                </button>
              </>
            ) : (
              <>
                <button type="button" onClick={() => { setDraft(note.body || ''); setEditing(true); setError('') }}>
                  <Pencil size={14} /> Editar
                </button>
                <button type="button" onClick={() => setConfirming(true)}>
                  <Trash2 size={14} /> Apagar
                </button>
              </>
            )}
          </div>
        )
      )}
    </article>
  )
}

export default NoteMessage
